import { render, staticRenderFns } from "./ComTaskFooter.vue?vue&type=template&id=26b84c24&"
import script from "./ComTaskFooter.vue?vue&type=script&lang=js&"
export * from "./ComTaskFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports